export const StatusType = Object.freeze({
    Submitted: {
        key: "Submitted",
        value: "Submitted"
    },
    CreditBlocked: {
        key: "CreditBlocked",
        value: "Credit Blocked"
    },
    Hold: {
        key: "Hold",
        value: "Hold"
    },
    Confirmed: {
        key: "Confirmed",
        value: "Confirmed"
    },
    DeliveryInProgress: {
        key: "DeliveryInProgress",
        value: "Delivery In Progress"
    },
    DeliveryComplete: {
        key: "DeliveryComplete",
        value: "Delivery Complete"
    },
    Settled: {
        key: "Settled",
        value: "Settled"
    },
    Cancelled: {
        key: "Cancelled",
        value: "Cancelled"
    },
    Failed: {
        key: "Failed",
        value: "Failed"
    },
    Deleted: {
        key: "Deleted",
        value: "Deleted"
    }
})